import { Module } from 'vuex';
import { updateGoogleDocs } from '@/dealroom/google-docs/store/update-google-docs.store';
import { IDealroomState } from '@/dealroom/store/dealroom.types';
import { state } from '@/dealroom/store/dealroom.constants';
import { contentLink } from '@/content-link/store/content-link.store';
import { recipient } from '@/dealroom/recipients/store/recipient.store';
import { createPage } from '@/dealroom/create-page/store/create-page.store';
import { actions } from '@/dealroom/store/dealroom.actions';
import { getters } from '@/dealroom/store/dealroom.getters';
import { mutations } from '@/dealroom/store/dealroom.mutations';
import { fields } from '@/dealroom/fields/store/field.store';
import { RootState } from '@/store/store';

export const dealroom: Module<IDealroomState, RootState> = {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
  modules: {
    createPage,
    contentLink,
    updateGoogleDocs,
    recipient,
    fields,
  },
};
